/**
 * Product Block Add to Cart functionality
 * Handles AJAX add to cart for product blocks with single variants
 */

class ProductBlockAddToCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Find all product block add to cart forms
    const forms = document.querySelectorAll(
      '.product-block__add-to-cart-form[data-ajax-add-to-cart="true"]'
    );

    forms.forEach((form) => {
      form.addEventListener("submit", this.handleSubmit.bind(this));
    });
  }

  /**
   * Handles submission of the product block add to cart form.
   * @param {object} evt - Event object.
   */
  async handleSubmit(evt) {
    evt.preventDefault();

    const form = evt.target;
    const submitBtn = form.querySelector('button[type="submit"]');

    if (submitBtn.getAttribute("aria-disabled") === "true") return;

    // Disable button until submission is complete
    submitBtn.setAttribute("aria-disabled", "true");
    submitBtn.classList.add("is-loading");

    const formData = new FormData(form);
    const sectionsToUpdate = ["page-header", "cart-drawer"]
      .map((sel) => document.querySelector(sel))
      .filter((el) => el);
    const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);

    formData.append("sections_url", window.location.pathname);
    formData.append("sections", sectionIds.join(","));

    const fetchRequestOpts = {
      method: "POST",
      headers: {
        Accept: "application/javascript",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    };

    try {
      const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
      const data = await response.json();

      let error =
        typeof data.description === "string" ? data.description : data.message;
      if (data.errors && typeof data.errors === "object") {
        error = Object.entries(data.errors).map((item) => item[1].join(", "));
      }

      if (data.status) {
        // Show error if any
        console.error("Add to cart error:", error);
      }

      if (!response.ok) throw new Error(response.status);

      // Update cart sections
      if (
        data.sections &&
        sectionsToUpdate.length === Object.keys(data.sections).length
      ) {
        sectionsToUpdate.forEach((el) => {
          el.updateFromCartChange(data.sections[el.dataset.sectionId]);
        });
      } else {
        // Fallback cart update
        this.dispatchEvent(
          new CustomEvent("on:cart:change", { bubbles: true })
        );
      }

      // Show notification or open drawer based on theme settings
      if (theme.settings.afterAddToCart === "notification") {
        const notification = document
          .getElementById("AddedNotification")
          ?.content.firstElementChild.cloneNode(true);

        if (notification) {
          notification.dataset.productTitle = data.product_title;
          let notificationContainer = document.querySelector(
            ".pageheader--sticky"
          );
          if (!notificationContainer) {
            notificationContainer = document.querySelector("body");
          }
          notificationContainer.appendChild(notification);
        }
      } else if (theme.settings.afterAddToCart === "drawer") {
        document.querySelector(".js-cart-drawer")?.open();
      }

      // Dispatch cart add event
      this.dispatchEvent(
        new CustomEvent("on:cart:add", {
          bubbles: true,
          detail: {
            variantId: data.variant_id,
          },
        })
      );
      const drawer = document.querySelector(".js-cart-drawer");
      if (drawer && drawer.classList.contains("empty-cart")) {
        drawer.classList.remove("empty-cart");
      }

      // Show success state
      submitBtn.classList.add("is-success");
      submitBtn.removeAttribute("aria-disabled");

      setTimeout(() => {
        submitBtn.classList.remove("is-loading");
        submitBtn.classList.remove("is-success");
      }, 2000);
    } catch (error) {
      console.error("Add to cart error:", error);

      // Dispatch error event
      this.dispatchEvent(
        new CustomEvent("on:cart:error", {
          bubbles: true,
          detail: {
            error: error.message,
          },
        })
      );

      // Re-enable button
      submitBtn.classList.remove("is-loading");
      submitBtn.classList.remove("is-success");
      submitBtn.removeAttribute("aria-disabled");
    }
  }
}

// Register the custom element
customElements.define("product-block-add-to-cart", ProductBlockAddToCart);

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new ProductBlockAddToCart();
});

// Also initialize for dynamically loaded content
document.addEventListener("shopify:section:load", () => {
  new ProductBlockAddToCart();
});
